import './SceletonMenu.css';
import React from 'react';

export function SceletonRecipe(props) { 
  const [length, setLength] = React.useState(0)
 
  
  return (
    <div className='sceleton-menu'>
    { [...Array(props.limit)].map((item, index) =>  
      <div className='pattern__block'> 
      <div className='pattern__image flare'> </div>
           
              <div className='pattern__icon2 flare'></div>
    </div>
        )}
  </div>
  )
}